module.exports = __webpack_public_path__ + "static/img/sph.c57c575c.jpg";